module.exports = __webpack_public_path__ + "img/icon_arrow-right.55229f53.svg";